"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageFieldView = exports.CSS = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var theme_1 = require("../../../components/theme");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var capture_thumbnail_1 = require("../../capture.thumbnail/capture.thumbnail");
exports.CSS = {
    capture: 'c-Image__capture'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.capture] = {
        padding: theme_1.DefaultTheme.space(1)
    },
    _a));
exports.ImageFieldView = {
    viewInline: function (field) {
        var captures = field.getCaptures();
        if (captures.length > 0) {
            return String(captures.length);
        }
        return '';
    },
    hasDetail: function (field) {
        return field.getCaptures().length > 0;
    },
    viewDetail: function (field) {
        var ctx = { className: exports.CSS.capture };
        var collection = field.collection;
        var captureChildren = [];
        for (var _i = 0, _a = field.getCaptures(); _i < _a.length; _i++) {
            var capture = _a[_i];
            ctx.title = services_1.Services.DateTime.formatDateTime(capture.collectedAt.iso);
            captureChildren.push(capture_thumbnail_1.CaptureThumbnail.view(collection, capture, ctx));
        }
        return mithril_1.m.fragment({}, captureChildren);
    },
    viewEdit: function (field, state) {
        return exports.ImageFieldView.viewInline(field, state);
    },
    hasClear: function (field) {
        return false;
    },
    canUpload: function (field) {
        var currentUser = services_1.Services.User.current;
        var userProfile = currentUser ? services_1.Services.UserProfile.get(currentUser.objectId) : null;
        var hasPreviousCaptures = core_shared_1.CaptureProvider.getCaptureIds(field.collection).length !== 0;
        return hasPreviousCaptures && (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_OFFICE_IMAGE_UPLOAD) && services_1.Services.UserProfile.isOneOf(userProfile, [core_api_1.IkeUserRole.USER, core_api_1.IkeUserRole.EDITOR, core_api_1.IkeUserRole.ROOT, core_api_1.IkeUserRole.DATA_ADMIN]));
    }
};
//# sourceMappingURL=image.field.view.js.map